// extracted by mini-css-extract-plugin
module.exports = {"pickup-address":"jn5PcI","pickupAddress":"jn5PcI"};